import React, { useState } from 'react';

import Accordion from 'b2b-ui-components-lib/lib/components/accordion';
import Button from 'b2b-ui-components-lib/lib/components/button';

import { FormBuilder } from 'featureLib/FormBuilder';
import { isFormValid } from 'featureLib/FormBuilder/form.validator';
import { getVisibleFormFields } from 'common/utils/app.utils';

import './index.scss';

export const PanGstAccordion = ({ onSubmit, formSchema, onFormSubmit, onFormChange, loader, disableBtn, pangstAccordionExpanded, addressPara, showAddress }) => {
  const getHeading = () => {
    return (
      <div className="get_heading">
        <h2 className="title-head">
          GSTIN / PAN Details
          {/* <span>All fields are mandatory unless marked optional.</span> */}
        </h2>
      </div>
    );
  };

  const isProceedDisabled = () => {
    const filteredFields = getVisibleFormFields({ ...formSchema });
    const isFormNotValid = !isFormValid(filteredFields);

    return isFormNotValid || disableBtn;
  };

  return (
    <div className="order_form pan_gst_form">
      <Accordion title={getHeading()} isExpanded={pangstAccordionExpanded} autoScrollOnExpand={false} variant="round">
        <div className="form_section">
          <div>
            <div className="row">
              <FormBuilder formConfig={formSchema} onSubmit={onFormSubmit} onChange={onFormChange}></FormBuilder>
            </div>
            {showAddress && (
              <div className="address-para" title={addressPara}>
                <div
                  style={{
                    fontWeight: 'bold',
                    fontSize: '16px'
                  }}
                >
                  Address :
                </div>
                <div className="address-input" style={{ fontSize: '16px' }}>
                  {addressPara}
                </div>
              </div>
            )}
          </div>
          {/* <div className="btn_action">
            <Button onClick={onSubmit} buttonClass="btnClass" disabled={isProceedDisabled()}>
              Next
              {loader && <span className="loading_icon"></span>}
            </Button>
          </div> */}
        </div>
      </Accordion>
    </div>
  );
};
export default PanGstAccordion;
